"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.form.source.file': 'Quelldatei scannen und Schulung erstellen',
    'tutorial.form.scanPages.label': 'Seitenbereich des Indexes / Inhaltsverzeichnisses',
    'tutorial.form.scanSourceFile': 'Quelldatei scannen und das Tutorial-Formular ausfüllen',
    'tutorial.form.regenerateFromPdf': 'Aus Quelldatei neu generieren',
    'tutorial.form.regenerateFromPdf.title': 'Schulung aus der Quelldatei neu generieren?',
    'tutorial.form.regenerateFromPdf.confirm': 'Der Inhalt der Schulung wird anhand der Quelldatei neu generiert und kann vorhandene Inhalte ersetzen. Möchtest du fortfahren?',
    'tutorial.form.tutorialGoal': 'Ziel der Schulung',
    'tutorial.form.tutorialGoalPlaceholder': 'Beschreibe, was der Teilnehmer nach Abschluss dieser Schulung können soll...',
    'tutorial.form.examplePrompts_1': 'Erstelle eine Schulung für Anfänger über die Grundlagen des Skifahrens, mit Schritten, Abschnitten und Aufgaben',
    'tutorial.form.examplePrompts_2': 'Schreibe die Beschreibung und den Einleitungstext so um, dass sie zum Schulungsziel passen',
    'tutorial.form.examplePrompts_3': 'Füge jedem Abschnitt dieser Schulung eine kurze Aufgabenliste hinzu',
    'tutorial.form.scanNeedsData': 'Fülle mindestens Name, Ziel oder Beschreibung aus (oder füge Schritte hinzu), damit die KI etwas zum Erweitern hat',
    'tutorial.form.start.title': 'Wie möchtest du beginnen?',
    'tutorial.form.start.onboarding.title': 'KI-Kursgenerator',
    'tutorial.form.start.onboarding.description': 'Beantworte einen kurzen, geführten Fragebogen zu deinem Kurs. Die KI gestaltet die Schulung anhand deiner Antworten.',
    'tutorial.form.start.onboarding.action': 'Geführten Fragebogen starten',
    'tutorial.form.start.form.title': 'Leeres Tutorial',
    'tutorial.form.start.form.description': 'Fülle das Formular selbst aus, scanne eine Quelldatei oder bitte den KI-Assistenten um Hilfe. Das Onboarding kannst du später über den Formularkopf hinzufügen.',
    'tutorial.form.start.form.action': 'Formular öffnen',
    'tutorial.form.start.form.how.title': 'So funktioniert es',
    'tutorial.form.start.form.how.step1': 'Benenne das Tutorial, wähle eine Kategorie und ergänze Beschreibung und Logo.',
    'tutorial.form.start.form.how.step1.title': 'Grundlegende Angaben festlegen',
    'tutorial.form.start.form.how.step2': 'Erstelle Schritte und Abschnitte und ordne sie in der gewünschten Reihenfolge an.',
    'tutorial.form.start.form.how.step2.title': 'Die Struktur erstellen',
    'tutorial.form.start.form.how.step3': 'Ergänze Abschnittsinhalte und Anhänge wie Dateien, Bilder und Videos.',
    'tutorial.form.start.form.how.step3.title': 'Lernmaterialien hinzufügen',
    'tutorial.form.start.form.how.step4': 'Füge Aufgaben hinzu, die Teilnehmer beim Lernen abhaken können.',
    'tutorial.form.start.form.how.step4.title': 'Aufgaben hinzufügen',
    'tutorial.form.start.how.title': 'So funktioniert es',
    'tutorial.form.start.how.step1': 'Du durchläufst einen kurzen Fragebogen Schritt für Schritt: Kursgrundlagen, Zielgruppe, Struktur und Dauer, Lehrstil, Materialien, Lernmodell und Zertifizierung.',
    'tutorial.form.start.how.step1.title': 'Ein paar Fragen beantworten',
    'tutorial.form.start.how.step2': 'Deine Antworten werden der Schulung beigefügt und zusammen mit ihr gespeichert.',
    'tutorial.form.start.how.step2.title': 'Antworten mit dem Tutorial speichern',
    'tutorial.form.start.how.step3': 'Die KI nutzt sie als Anweisungen, wenn sie Inhalte erzeugt - im KI-Assistenten und beim Scannen einer Quelldatei - damit Struktur, Tiefe, Ton und Übungen zu deinen Entscheidungen passen.',
    'tutorial.form.start.how.step3.title': 'Inhalte nach deinen Wünschen gestalten',
    'tutorial.form.assistant': 'Assistent',
    'tutorial.scanned': 'Schulung erfolgreich gescannt und Formular ausgefüllt',
    'tutorial.scanFailed': 'Die Schulung konnte nicht gescannt werden',
    'tutorial.category.loadFailed': 'Kategorien konnten nicht geladen werden',
    'tutorial.form.category': 'Kategorie',
    'tutorial.form.no_cat': 'Keine Kategorie',
    'tutorial.form.logo': 'Schulungslogo',
    'tutorial.form.source.label': 'Quelle',
    'tutorial.form.source.ai': 'Von KI generiert',
    'tutorial.form.sourceFile.label': 'Quelldatei',
    'tutorial.form.sourceFile.placeholder': 'Quelldatei auswählen...',
    'tutorial.form.source_pages': 'Quellseiten des Abschnitts',
    'tutorial.form.expireAt': 'Ablaufdatum',
    'tutorial.form.scanKnowledge.label': 'Oder verwende einen Wissenseintrag als Scan-Quelle',
    'tutorial.form.scanKnowledge.none': 'Kein Wissenseintrag ausgewählt',
    'tutorial.expired': 'Abgelaufen',
    'tutorial.form.source.ai.description': 'Der Inhalt der Schulung wird in Echtzeit von der KI generiert.',
    'tutorial.form.source.file.description': 'Lade eine Quelldatei hoch (z. B. PDF). Ihr Inhaltsverzeichnis wird gescannt, um die Schulung aufzubauen.',
    'tutorial.form.scanSourceFile.description.ai': 'Die KI analysiert die bereits eingegebenen Daten und ergänzt die fehlende Struktur der Schulung (Abschnitte und Schritte).',
    'tutorial.form.scanSourceFile.description.file': 'Die Quelldatei wird gescannt, um die vollständige Struktur der Schulung und ihre Inhalte (Abschnitte, Schritte und Texte) zu erzeugen.',
    'tutorial.form.onboardingAttached': 'Onboarding hinzugefügt',
    'tutorial.form.attachments': 'Anhänge',
    'tutorial.form.addFile': 'Datei hinzufügen',
    'tutorial.form.sectionFileMiniature': 'Miniaturbild',
    'tutorial.form.sectionFileRequired': 'Wähle vor dem Hinzufügen eine Datei aus.',
    'tutorial.form.onboarding.button': 'Onboarding',
    'tutorial.form.onboarding.submit': 'Kurs generieren',
    'tutorial.form.onboarding.stepLabel': 'Schritt',
    'tutorial.form.onboarding.step1': 'Grundinformationen',
    'tutorial.form.onboarding.step2': 'Zielgruppe',
    'tutorial.form.onboarding.step3': 'Kursparameter',
    'tutorial.form.onboarding.step4': 'Kursstil',
    'tutorial.form.onboarding.step5': 'Zu erstellende Materialien',
    'tutorial.form.onboarding.step6': 'Multimedia',
    'tutorial.form.onboarding.step7': 'Lernmodell',
    'tutorial.form.onboarding.step8': 'Zertifizierung',
    'tutorial.form.onboarding.name': 'Kursname',
    'tutorial.form.onboarding.category': 'Kategorie',
    'tutorial.form.onboarding.goals': 'Kursziel',
    'tutorial.form.onboarding.description': 'Kursbeschreibung (max. 2000 Zeichen)',
    'tutorial.form.onboarding.level': 'Wissensstand',
    'tutorial.form.onboarding.participants': 'Anzahl der Teilnehmer',
    'tutorial.form.onboarding.industries': 'Branche',
    'tutorial.form.onboarding.targetGroups': 'Zielgruppe',
    'tutorial.form.onboarding.totalHours': 'Gesamtdauer des Kurses',
    'tutorial.form.onboarding.modulesCount': 'Anzahl der Schritte',
    'tutorial.form.onboarding.lessonsPerModule': 'Abschnitte pro Schritt',
    'tutorial.form.onboarding.lessonMinutes': 'Durchschnittliche Abschnittsdauer',
    'tutorial.form.onboarding.intensity': 'Intensität',
    'tutorial.form.onboarding.styles': 'Unterrichtsstil',
    'tutorial.form.onboarding.tone': 'Kommunikationston',
    'tutorial.form.onboarding.materials': 'Die KI soll erstellen',
    'tutorial.form.onboarding.aiAvatar': 'KI-Avatar',
    'tutorial.form.onboarding.slides': 'Folien generieren',
    'tutorial.form.onboarding.narration': 'Sprecherstimme generieren',
    'tutorial.form.onboarding.quizVideo': 'Quiz-Video generieren',
    'tutorial.form.onboarding.graphics': 'Grafiken generieren',
    'tutorial.form.onboarding.graphicsStyle': 'Grafikstil',
    'tutorial.form.onboarding.theoryPracticeRatio': 'Theorie ←→ Praxis',
    'tutorial.form.onboarding.exercisesCount': 'Anzahl der Übungen',
    'tutorial.form.onboarding.caseStudiesCount': 'Anzahl der Fallstudien',
    'tutorial.form.onboarding.finalProject': 'Abschlussprojekt',
    'tutorial.form.onboarding.finalExam': 'Abschlussprüfung',
    'tutorial.form.onboarding.certificate': 'Teilnahmezertifikat',
    'tutorial.form.onboarding.passThreshold': 'Bestehensgrenze',
    'tutorial.form.onboarding.numbered': 'Nummeriertes Zertifikat',
    'tutorial.form.onboarding.qrVerification': 'Zertifikatsprüfung per QR-Code',
    'tutorial.form.onboarding.goals.knowledge': 'Wissen erwerben',
    'tutorial.form.onboarding.goals.skills': 'Fähigkeiten erwerben',
    'tutorial.form.onboarding.goals.certification': 'Zertifizierung',
    'tutorial.form.onboarding.goals.process_implementation': 'Prozesseinführung',
    'tutorial.form.onboarding.goals.sales_increase': 'Umsatzsteigerung',
    'tutorial.form.onboarding.goals.company_automation': 'Unternehmensautomatisierung',
    'tutorial.form.onboarding.goals.career_growth': 'Karriereentwicklung',
    'tutorial.form.onboarding.goals.exam_preparation': 'Prüfungsvorbereitung',
    'tutorial.form.onboarding.levels.beginner': 'Anfänger',
    'tutorial.form.onboarding.levels.intermediate': 'Fortgeschritten',
    'tutorial.form.onboarding.levels.advanced': 'Weit fortgeschritten',
    'tutorial.form.onboarding.levels.expert': 'Experte',
    'tutorial.form.onboarding.industries.b2b': 'B2B',
    'tutorial.form.onboarding.industries.ecommerce': 'E-Commerce',
    'tutorial.form.onboarding.industries.services': 'Dienstleistungen',
    'tutorial.form.onboarding.industries.production': 'Produktion',
    'tutorial.form.onboarding.industries.accounting': 'Buchhaltung',
    'tutorial.form.onboarding.industries.it': 'IT',
    'tutorial.form.onboarding.industries.education': 'Bildung',
    'tutorial.form.onboarding.industries.real_estate': 'Immobilien',
    'tutorial.form.onboarding.industries.medicine': 'Medizin',
    'tutorial.form.onboarding.industries.other': 'Sonstige',
    'tutorial.form.onboarding.targetGroups.business_owners': 'Unternehmer',
    'tutorial.form.onboarding.targetGroups.ceo': 'CEOs',
    'tutorial.form.onboarding.targetGroups.managers': 'Manager',
    'tutorial.form.onboarding.targetGroups.sales': 'Vertriebsmitarbeiter',
    'tutorial.form.onboarding.targetGroups.hr': 'HR',
    'tutorial.form.onboarding.targetGroups.marketing': 'Marketing',
    'tutorial.form.onboarding.targetGroups.developers': 'Entwickler',
    'tutorial.form.onboarding.targetGroups.freelancers': 'Freelancer',
    'tutorial.form.onboarding.targetGroups.employees': 'Mitarbeiter',
    'tutorial.form.onboarding.intensities.micro_learning': 'Microlearning',
    'tutorial.form.onboarding.intensities.standard': 'Standard',
    'tutorial.form.onboarding.intensities.academy': 'Akademie',
    'tutorial.form.onboarding.intensities.masterclass': 'Masterclass',
    'tutorial.form.onboarding.styles.expert': 'Expertenstil',
    'tutorial.form.onboarding.styles.business': 'Geschäftlich',
    'tutorial.form.onboarding.styles.formal': 'Formell',
    'tutorial.form.onboarding.styles.practical': 'Praxisnah',
    'tutorial.form.onboarding.styles.coaching': 'Coaching',
    'tutorial.form.onboarding.styles.storytelling': 'Storytelling',
    'tutorial.form.onboarding.styles.mentoring': 'Mentoring',
    'tutorial.form.onboarding.styles.workshop': 'Workshop',
    'tutorial.form.onboarding.tones.professional': 'Professionell',
    'tutorial.form.onboarding.tones.friendly': 'Freundlich',
    'tutorial.form.onboarding.tones.dynamic': 'Dynamisch',
    'tutorial.form.onboarding.tones.premium': 'Premium',
    'tutorial.form.onboarding.tones.corporate': 'Unternehmensstil',
    'tutorial.form.onboarding.materials.outline': 'Gliederung',
    'tutorial.form.onboarding.materials.full_lessons': 'Vollständige Lektionsinhalte',
    'tutorial.form.onboarding.materials.presentations': 'Präsentationen',
    'tutorial.form.onboarding.materials.pdf': 'PDF',
    'tutorial.form.onboarding.materials.workbook': 'Arbeitsheft',
    'tutorial.form.onboarding.materials.checklists': 'Checklisten',
    'tutorial.form.onboarding.materials.quizzes': 'Quizze',
    'tutorial.form.onboarding.materials.exams': 'Prüfungen',
    'tutorial.form.onboarding.materials.certificate': 'Zertifikat',
    'tutorial.form.onboarding.materials.practical_tasks': 'Praktische Aufgaben',
    'tutorial.form.onboarding.materials.worksheets': 'Arbeitsblätter',
    'tutorial.form.onboarding.materials.prompt_pack': 'Prompt Pack',
    'tutorial.form.onboarding.materials.case_study': 'Fallstudie',
    'tutorial.form.onboarding.materials.landing_page': 'Landingpage',
    'tutorial.form.onboarding.materials.sales_webinar': 'Verkaufswebinar',
    'tutorial.form.onboarding.materials.email_campaign': 'E-Mail-Kampagne',
    'tutorial.form.onboarding.materials.social_posts': 'Social-Media-Beiträge',
    'tutorial.form.onboarding.materials.meta_ads': 'Meta-Anzeigen',
    'tutorial.form.onboarding.materials.google_ads': 'Google-Anzeigen',
    'tutorial.form.onboarding.imageStyles.photorealistic': 'Fotorealistisch',
    'tutorial.form.onboarding.imageStyles.corporate': 'Corporate',
    'tutorial.form.onboarding.imageStyles.minimalist': 'Minimalistisch',
    'tutorial.form.onboarding.imageStyles.3d': '3D',
    'tutorial.form.onboarding.imageStyles.infographic': 'Infografiken',
    'tutorial.form.onboarding.imageStyles.comic': 'Comic',
    'tutorial.form.onboarding.imageStyles.premium': 'Premium',
    'tutorial.form.sourcePreview': 'Quellvorschau',
    'tutorial.form.basicInfo': 'Grundinformationen',
    'tutorial.form.name': 'Name der Schulung',
    'tutorial.form.namePlaceholder': 'Schulungsnamen eingeben...',
    'tutorial.form.avatar': 'Führender Avatar',
    'tutorial.form.selectAvatar': 'Avatar auswählen...',
    'tutorial.form.company': 'Unternehmen / Auftrag',
    'tutorial.form.selectCompany': 'Unternehmen auswählen...',
    'tutorial.form.description': 'Allgemeine Beschreibung',
    'tutorial.form.descriptionPlaceholder': 'Beschreibe kurz, was in dieser Schulung behandelt wird...',
    'tutorial.form.introText': 'Einführung für Teilnehmer',
    'tutorial.form.introTextPlaceholder': 'Schreibe einen Einführungstext, der den Teilnehmer begrüßt...',
    'tutorial.form.active': 'Aktiv',
    'tutorial.form.steps': 'Schulungsschritte',
    'tutorial.form.step': 'Schritt',
    'tutorial.form.addStep': 'Schritt hinzufügen',
    'tutorial.form.stepName': 'Schrittname',
    'tutorial.form.stepNamePlaceholder': 'Schrittnamen eingeben',
    'tutorial.form.stepDescription': 'Schrittbeschreibung',
    'tutorial.form.stepDescriptionPlaceholder': 'Schrittbeschreibung eingeben (optional)',
    'tutorial.form.selectStep': 'Schritt auswählen...',
    'tutorial.form.sections': 'Abschnitte',
    'tutorial.form.section': 'Abschnitt',
    'tutorial.form.sectionName': 'Abschnittsname',
    'tutorial.form.sectionNamePlaceholder': 'Abschnittsnamen eingeben...',
    'tutorial.form.sectionIntro': 'Abschnittseinführung',
    'tutorial.form.sectionIntroPlaceholder': 'Beschreibe, was der Teilnehmer in diesem Abschnitt lernen wird...',
    'tutorial.form.sectionPrompt': 'Prompt (Wissen für den Abschnitt)',
    'tutorial.form.sectionPromptPlaceholder': 'Gib Wissen oder Anleitungen für diesen Abschnitt an...',
    'tutorial.form.addKnowledge': 'Wissen hinzufügen',
    'tutorial.form.selectedKnowledge': 'Ausgewähltes Wissen',
    'tutorial.form.files': 'Screenshot / Bildschirm',
    'tutorial.form.screenshot': 'Screenshot / Bildschirm',
    'tutorial.form.screenshotPlaceholder': 'Screenshot-Datei auswählen...',
    'tutorial.form.video': 'Video (MP4)',
    'tutorial.form.videoPlaceholder': 'Videodatei auswählen...',
    'tutorial.form.screenshotMini': 'Screenshot-Miniatur',
    'tutorial.form.screenshotMiniPlaceholder': 'Screenshot-Miniatur auswählen...',
    'tutorial.form.videoMini': 'Video-Miniatur',
    'tutorial.form.videoMiniPlaceholder': 'Video-Miniatur auswählen...',
    'tutorial.form.addSection': 'Abschnitt hinzufügen',
    'tutorial.form.scanProgress.step': 'Schritt',
    'tutorial.form.scanProgress.section': 'Abschnitt',
    'tutorial.form.scanProgress.reading': 'Quelldatei wird gelesen...',
    'tutorial.form.scanProgress.index': 'Struktur wird analysiert und Abschnitte werden geplant...',
    'tutorial.form.scanProgress.content': 'Abschnittsinhalt wird geschrieben',
    'tutorial.form.scanProgress.todos': 'Aufgaben werden erstellt',
    'tutorial.form.todoItems': 'Todo-Elemente',
    'tutorial.form.todoItemPlaceholder': 'Todo-Element eingeben...',
    'tutorial.form.todoDescription': 'Verwalte die Todo-Liste für diese Schulung',
    'tutorial.form.addTodoItem': 'Todo hinzufügen',
    'tutorial.form.removeTodoItem': 'Todo entfernen',
    'tutorial.form.noTodoItems': 'Keine Todo-Elemente für diese Schulung',
    'tutorial.form.updatedFromAI': 'Formular vom KI-Assistenten aktualisiert',
    'tutorial.form.editor.addField': 'Feld hinzufügen',
    'tutorial.form.editor.addOption': 'Option hinzufügen',
    'tutorial.form.editor.fieldType': 'Feldtyp',
    'tutorial.form.editor.label': 'Beschriftung',
    'tutorial.form.editor.max': 'Max.',
    'tutorial.form.editor.min': 'Min.',
    'tutorial.form.editor.moveDown': 'Nach unten',
    'tutorial.form.editor.moveUp': 'Nach oben',
    'tutorial.form.editor.multiple': 'Mehrfachauswahl',
    'tutorial.form.editor.name': 'Name',
    'tutorial.form.editor.optionLabel': 'Optionsbeschriftung',
    'tutorial.form.editor.optionValue': 'Optionswert',
    'tutorial.form.editor.options': 'Optionen',
    'tutorial.form.editor.placeholder': 'Platzhalter',
    'tutorial.form.editor.remove': 'Entfernen',
    'tutorial.form.editor.required': 'Pflichtfeld',
    'tutorial.form.editor.rows': 'Zeilen',
    'tutorial.form.editor.showValue': 'Wert anzeigen',
    'tutorial.form.editor.step': 'Schrittweite',
    'tutorial.form.editor.submitLabel': 'Beschriftung der Senden-Schaltfläche',
    'tutorial.form.editor.type': 'Typ',
    'tutorial.form.editor.unit': 'Einheit',
    'tutorial.form.editor.fieldType.input': 'Texteingabe',
    'tutorial.form.editor.fieldType.textarea': 'Textbereich',
    'tutorial.form.editor.fieldType.select': 'Dropdown',
    'tutorial.form.editor.fieldType.radio': 'Optionsfelder',
    'tutorial.form.editor.fieldType.checkbox': 'Kontrollkästchen',
    'tutorial.form.editor.fieldType.date': 'Datum',
    'tutorial.form.editor.fieldType.switch': 'Schalter',
    'tutorial.form.editor.fieldType.slider': 'Schieberegler',
    'tutorial.form.editor.inputFieldType.text': 'Text',
    'tutorial.form.editor.inputFieldType.number': 'Zahl',
    'tutorial.form.editor.inputFieldType.email': 'E-Mail',
    'tutorial.form.editor.inputFieldType.password': 'Passwort',
    'tutorial.form.editor.inputFieldType.tel': 'Telefon',
    'tutorial.form.editor.inputFieldType.url': 'URL',
    'tutorial.form.editor.inputFieldType.search': 'Suche',
    'tutorial.form.editor.inputFieldType.date': 'Datum',
    'tutorial.form.editor.inputFieldType.datetime-local': 'Datum und Uhrzeit',
    'tutorial.form.editor.inputFieldType.time': 'Uhrzeit',
    'tutorial.form.editor.defaultSubmitLabel': 'Senden',
    'tutorial.form.editor.defaultFieldLabel': 'Neues Feld',
    'tutorial.form.editor.defaultOptionLabel': 'Option {index}',
    'tutorial.form.editor.formEditor': 'Formulareditor',
    'tutorial.form.editor.formIncluded': 'Formular hinzugefügt',
    'tutorial.form.editor.saveForm': 'Formular speichern',
};
